export default "/images/vendor/flag-icon-css/flags/4x3/zw.svg?f5ceeff7d65d0b5e33b79719b9948b59";